import Vue from "vue";

export default {
    recuperarJustificativas() {
        return Vue.axios.get("justificativas");
    },
};
